import { render, staticRenderFns } from "./Test3.vue?vue&type=template&id=c9f93c76&scoped=true&"
import script from "./Test3.vue?vue&type=script&lang=js&"
export * from "./Test3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f93c76",
  null
  
)

export default component.exports